import { useEffect, useState, createElement } from "react";
export function useCustomElementWithProps(tagName, customProps, htmlProps) {
    const [element, setElement] = useState(null);
    useEffect(() => {
        if (element) {
            element.customProps = customProps;
        }
    }, [element, customProps]);
    return createElement(tagName, Object.assign(Object.assign({}, htmlProps), { ref: setElement }));
}
